import moment from 'moment';

export const MAX_NIGHTS = 5;

export function calculateNumberOfNights(startDate, endDate) {
  return moment(endDate).diff(moment(startDate), 'days');
}

export function getYearsOptions(startYear, endYear) {
  const years = {};
  for (let i = startYear; i <= endYear; i++) {
    years[i] = i;
  }

  return years;
}

export function getFutureYearsOptions(numberOfYears) {
  const currentYear = moment().year();
  return getYearsOptions(currentYear, currentYear + numberOfYears);
}

export function isMaxStayExceeded(startMoment, endMoment) {
  return (
    startMoment && endMoment && endMoment.diff(startMoment, 'days') > MAX_NIGHTS
  );
}
